var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg"},[(_vm.verified)?_c('div',{staticClass:"circle",class:{ 'circle--online': _vm.online }}):_c('i',{staticClass:"fas fa-times times-red",attrs:{"title":"Nicht verifiziert"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }